import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BRAND, CONTACT, DISCLAIMER } from "../data/content";

export function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("Welcome to the ritual — you're on the list.");
    setEmail("");
  };
  return (
    <footer className="relative overflow-hidden bg-cream-2 text-moss grain border-t border-[#E4DDD0]" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-20">
        <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr_1fr]">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-cream ring-1 ring-gold/50 overflow-hidden">
                <img src={BRAND.logo} alt="Cured & Clear emblem" className="h-full w-full object-cover scale-110" />
              </span>
              <h3 className="font-serif text-4xl">Cured <span className="text-gold">&</span> Clear</h3>
            </div>
            <p className="max-w-sm text-muted leading-relaxed">
              Ingredient-first body butter made with rare natural butters sourced from Africa. Quality you can read on
              the label and feel on your skin.
            </p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">Explore</p>
            <ul className="space-y-3 text-moss/80">
              <li><Link to="/shop" className="hover:text-gold transition-colors" data-testid="footer-link-shop">Shop</Link></li>
              <li><Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-link-about">Our Story</Link></li>
              <li><Link to="/glossary" className="hover:text-gold transition-colors" data-testid="footer-link-glossary">Ingredient Glossary</Link></li>
              <li><Link to="/faq" className="hover:text-gold transition-colors" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link to="/admin" className="hover:text-gold transition-colors" data-testid="footer-link-admin">Admin</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">Contact</p>
            <ul className="space-y-3 text-moss/80">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors break-all" data-testid="footer-contact-email">
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-sm leading-relaxed" data-testid="footer-contact-address">{CONTACT.address}</li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">The Ritual Letter</p>
            <p className="text-muted mb-4 text-sm">Ingredient education & early drops.</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="w-full bg-transparent border-b border-moss/30 py-2 text-sm placeholder:text-muted focus:outline-none focus:border-gold"
                data-testid="footer-newsletter-input"
              />
              <button className="btn-gold px-4 py-2 text-xs font-semibold uppercase tracking-wider rounded-sm" data-testid="footer-newsletter-submit">
                Join
              </button>
            </form>
          </div>
        </div>
        <p className="mt-16 max-w-4xl text-xs leading-relaxed text-muted/80" data-testid="footer-disclaimer">
          {DISCLAIMER}
        </p>
        <div className="mt-8 pt-8 border-t border-[#E4DDD0] flex flex-col sm:flex-row justify-between gap-4 text-xs text-muted font-mono">
          <span>© {new Date().getFullYear()} Cured & Clear. No fillers. No shortcuts.</span>
          <span>Sourced with integrity — Rare natural butters sourced from Africa</span>
        </div>
      </div>
    </footer>
  );
}
